export default "__VITE_ASSET__BPc18Nr9__"